import React from 'react';

export interface QuickActionButtonProps {
  name: string;
  icon: React.ReactNode;
  onClick?: () => void;
  isFullWidth?: boolean;
}

export const QuickActionButton: React.FC<QuickActionButtonProps> = ({
  name,
  icon,
  onClick,
  isFullWidth = true,
}) => {
  const handleButtonClick = () => {
    onClick?.();
  };

  return (
    <button
      type="button"
      onClick={handleButtonClick}
      className={`flex items-center justify-center gap-2 rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 transition-colors hover:border-gray-400 hover:bg-gray-50 dark:border-gray-600 dark:bg-gray-900 dark:text-gray-300 dark:hover:border-gray-500 dark:hover:bg-gray-800 ${isFullWidth ? 'w-full' : ''}`}
    >
      <div className="flex h-4 w-4 items-center justify-center text-gray-600 dark:text-gray-400">
        {icon}
      </div>
      <span>{name}</span>
    </button>
  );
};
